module.exports = __webpack_public_path__ + "img/liuhuahu.ea24ef01.png";